export default __webpack_public_path__ + "static/media/cert-fsi-cpttm-sc.e9e56893.jpg";